import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'App';

export class AppAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	GetConfiguracionApp(): AxiosPromise<any[]> {
		return this.cliente.get(`/ConfiguracionApp`);
	}

	GetEstado(): AxiosPromise<any[]> {
		return this.cliente.get(`/Estado`);
	}

	UpdateEstadoApp(nuevoEstado?:boolean): AxiosPromise<any[]> {
		return this.cliente.post({bloqueado:nuevoEstado}, `/ActualizarEstado`);
	}

	GetFechasFacturacion(tipo:string) : AxiosPromise<any[]> {
		return this.cliente.get(`/FechasFacturacion/${tipo}`);
	}

	GetTiposFacturacion() : AxiosPromise<any[]> {
		return this.cliente.get(`/TiposFacturacion`);
	}

	GetDatosFacturacion() : AxiosPromise<any[]> {
		return this.cliente.get(`/DatosFacturacion`);
	}

	GetFechasBloqueoParcial(): AxiosPromise<any[]>{
		return this.cliente.get(`/FechasBloqueoParcial`);
	}

	UpdateFechasBloqueoParcial(data:any): AxiosPromise<any[]> {
		console.log('UpdateFechasBloqueoParcial ',data)
		return this.cliente.post(data, `/ActualizarFechasBloqueoParcial`);
	}
}